<template>
  <b-card no-body class="mb-1 selected_chart rounded-4 v2_bg_light_gray" border-variant="light">
    <b-card-body class="d-flex align-items-center justify-content-between">
      <span class="v3_color_black_knight font_size_875rem">{{ itemTitle }}</span>
      <span class="survey-results__remove-chart d-inline-flex">
        <i
          :id="targetId"
          class="mdi mdi-close-circle-outline size-medium v2_color_med_gray"
          aria-hidden="true"
          @click="$emit('click')"
          @mouseover="showTooltip = true"
          @mouseout="onMouseOut"
        />
        <b-tooltip :show.sync="showTooltip" :target="targetId">
          {{ tooltipTitle }}
        </b-tooltip>
      </span>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'SurveySelectedChart',
  props: {
    itemTitle: {
      type: String,
      required: true,
    },
    itemId: {
      required: true,
    },
    tooltipTitle: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      showTooltip: false,
    };
  },
  computed: {
    targetId: function () {
      return `ssc_${this.itemId}`;
    },
  },
  methods: {
    onMouseOut: function () {
      this.showTooltip = false;
      this.$root.$emit('bv::hide::tooltip');
    }
  }
};
</script>

<style lang="scss" scoped>
  .selected_chart {
    min-height: 31px;
  }
</style>
